import * as React from 'react'

import { Text, TextName } from 'sdk'
import { CodeBlockWithTitle } from 'components/code-block-with-title/CodeBlockWithTitle'
import { Content } from 'sdk/components'

import alsaImage from './assets/alsa.jpg'
import classes from './style.module.scss'

const alsaCode = `static snd_pcm_extplug_callback_t
gpu_audio_callback = {
  .transfer = gpu_transfer,
  .init = gpu_init,
  .close = gpu_close,
};
static snd_pcm_sframes_t
gpu_transfer(snd_pcm_extplug_t *ext,
  const snd_pcm_channel_area_t *dst_areas,
  snd_pcm_uframes_t dst_offset,
  const snd_pcm_channel_area_t *src_areas,
  snd_pcm_uframes_t src_offset,
  snd_pcm_uframes_t size)
{
  snd_pcm_gpua_t *gpua = (snd_pcm_gpua_t *)ext;
  float *src, *dst;
  int channel_count;

  /* Calculate buffer locations */
  src = (float*) src_areas->addr +
    (src_areas->first + src_areas->step *
    src_offset)/(8*sizeof(float));
  dst = (float*) dst_areas->addr +
    (dst_areas->first + dst_areas->step *
    dst_offset)/(8*sizeof(float));
  channel_count = gpua->control_data->channels;
  gpu_audio->processor-
    >process_interleaved(src, dst, channel_count);
  return size;
}`

export const ALSASection: React.FC = () => {
  return (
    <section className={classes.content}>
      <Content gap={50}>
        <Text type={TextName.H2} className={classes.title}>
          Advanced Linux Sound Architecture (ALSA) integration example
        </Text>
        <img src={alsaImage} alt='' className={classes.image} />
      </Content>

      <CodeBlockWithTitle
        heading='Deploy GPU-accelerated audio in just a few lines of code'
        body="Here's how to deploy the same module across any GPU hardware"
        code={alsaCode}
      />
    </section>
  )
}
